import { Bell, Search, Settings } from "lucide-react";
import React from "react";

export default function Navbar() {
  return (
    <div className="px-4 py-4 bg-[#0B0D0F] border-b border-white/10">
      <div className="w-full flex flex-col md:flex-row justify-between items-center md:items-center gap-4 md:gap-0">
        {/* Search input */}
        <div className="relative flex items-center w-full md:w-[26rem]">
          <Search className="absolute left-3 w-5 h-5 text-gray-400" />
          <input
            type="text"
            placeholder="Search..."
            className="pl-10 pr-3 py-2 rounded-lg bg-[#1D2530] outline-none text-gray-200 w-full "
          />
        </div>

        {/* Right side */}
        <div className="flex flex-col md:flex-row md:items-center text-white w-full md:w-auto gap-4 md:gap-0 justify-between md:justify-end">
          {/* Icons */}
          <div className="flex gap-4 md:gap-8 px-0 md:px-4 justify-center">
            <Bell className="w-5 h-5" />
            <Settings className="w-5 h-5" />
          </div>

          {/* User Info */}
          <div className="flex gap-2 md:gap-4 border-t md:border-t-0 md:border-l border-white/10 px-0 md:px-4 pt-2 md:pt-0 items-center md:items-center">
            <div className="text-start md:text-end">
              <h1 className="text-sm md:text-base font-semibold">Mosi Ray</h1>
              <p className="text-xs md:text-sm text-gray-300">Administrator</p>
            </div>
            <img
              className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-blue-300"
              src=""
              alt="Profile"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
